// extracted by mini-css-extract-plugin
module.exports = {"reveal":"reveal_reveal__30gxp","visible":"reveal_visible__3rGdI"};